<template>
    <div class="home">
    <app-sidebar></app-sidebar>
    <!-- Shop by category section -->
    <div class="wrapper-content">
        <app-header></app-header>
        <div class="breadcrumb_box">
            <div class="container-fluid">
            <h2>Add Money</h2>
            </div>
        </div>
        <div class="addMoney">
            <div class="container">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
                <div class="addMoneyContainer">
                    <div class="walletBalance">
                        Wallet Balance
                        <span>{{currency}}{{totalBalance}}</span>
                    </div>
                    <div class="alert alert-success" v-if="success">
                        {{success}}
                    </div>
                    <div class="alert alert-danger" v-if="error">
                        {{ error }}
                    </div>
                        <form ref="form" class="input-animation addMoneyForm" @submit.prevent="handleSubmit" >
                            <div class="form-group input-field">
                                <label for="firstName">Enter Amount (₹)</label>
                                <input type="text" v-model="payment.amount" id="amount" name="amount" class="form-control" :class="{ 'is-invalid': submitted && $v.payment.amount.$error }" />
                                <div v-if="submitted && !$v.payment.amount.required" class="invalid-feedback">Amount is required</div>
                                <div v-if="submitted && !$v.payment.amount.numeric" class="invalid-feedback">Add only numeric value</div>
                            </div>

                            <div class="form-group promocode">
                                <input id="promocode" type="text" name="amount" value="" class="form-control" />
                                <label for="promocode">Apply Promocode</label>
                                <button class="btn btn-primary applyPromoBtn">Apply</button>
                            </div>
                            <div class="form-group">
                                <Ul class="radioBtns">
                                    <div v-if="paytmStatus == 'true'">
                                        <li>
                                            <input type="radio" name="paymentMethod" value="paytm" id="paytm" checked v-model="selected" />
                                            <label for="paytm">
                                            <img src="../assets/images/paytm.png" /> Paytm/Net Banking/Credit and Debit Card
                                            </label>
                                        </li>
                                    </div>
                                    <div v-if="payuStatus == 'true'">
                                        <li>
                                            <input type="radio" name="paymentMethod" id="payUMoney" value="payUMoney" v-model="selected" />
                                            <label for="payUMoney">
                                            <img src="../assets/images/payU.png" /> PayU Money
                                            </label>
                                        </li>
                                    </div>
                                    <div v-if="paypalStatus == 'true'">
                                        <li>
                                            <input type="radio" name="paymentMethod" id="paypal" value="paypal" v-model="selected" />
                                            <label for="paypal">
                                            <img src="../assets/images/paypal.png" /> Paypal
                                            </label>
                                        </li>
                                    </div>
                                </Ul>
                            </div>
                            <div class="addMoneyBtn">
                                <div v-show="selected != 'paypal'">
                                    <button class="btn btn-primary">Add Money</button>
                                </div>
                                <div v-show="selected === 'paypal'">
                                    <div id="paypal-button"></div>
                                </div>
                            </div>
                        </form>
                         <br><br><br>
                    </div>
                </div>
            </div>
        </div>
        <!-- <app-paypal></app-paypal> -->
        <div ref="parentSidebar" id="parentx">
            <app-footer></app-footer>
        </div>
</div>
</template>
<script>
// @ is an alias to /src
import {
  getmasterConfiguration
} from "./../services/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Paypalc from "../components/Paypal";
import paypal from 'paypal-checkout';
import Vuelidate from "vuelidate";
import Vue from 'vue';
import { required, numeric } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

const axios = require("axios");
const _baseUrl = process.env.VUE_APP_API_URL;
Vue.use(Vuelidate);
export default {
    components: {
        "app-header": Header,
        "app-sidebar": Sidebar,
        "app-footer": Footer,
        "app-paypal": Paypalc,
        Loading
      },
    data() {
        return {
            totalBalance: localStorage.getItem("walletBalance"),
            currency: localStorage.getItem("CurrencySymbol"),
            hostedFieldInstance: false,
            nonce: "",
            error: "",
            success:"",
            selected: "paytm",
            alert: false,
            paypalStatus: localStorage.getItem("paypalStatus"),
            paytmStatus: localStorage.getItem("paytmStatus"),
            payuStatus: localStorage.getItem("payuStatus"),
            submitted: false,
            isLoading: false,
            fullPage: true,
            payment: {
                amount: "",
            }
        };
    },
    validations: {
            payment: {
                amount: { required, numeric },
            }
        },
    methods:{
       handleSubmit(e) {
                this.submitted = true;
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
               // alert("SUCCESS!! :-)\n\n" + JSON.stringify(this.user));
            },
        sendDataPaypal ( data) {
            this.isLoading = true;
            let url = _baseUrl + "/customerApiv3/verifyTransaction";
            return new Promise((resolve, reject) => {
                axios.post(url, data.data)
                    .then(res => {
                        this.isLoading = false;
                        this.success= res.data.message;
                        this.totalBalance = res.data.order_data.walletBalance;
                        localStorage.setItem("walletBalance", this.totalBalance)
                        setTimeout( () => this.$router.push({ path: '/wallet'}), 3000);
                        // this.$router.push('/wallet') 
                        return resolve() 
                }).catch((err) => {
                    this.isLoading = false;
                    return reject(err)
                })
            })
        },
},

     mounted() {
            let  client = {
                sandbox: localStorage.getItem('paypayKey'),
                //production: 'EFNo9sAyqiOmnlRHsAdXiGBf6ULysEIfKUVsn58Pq6ilfGHVFn03iVvbWtfiht-irdJD_df1MECvmBC2'
            }
            let  payment = (data, actions) => {
                return actions.payment.create({
                payment: {
                    transactions: [
                        {
                        amount: { total:this.payment.amount, currency: 'USD' }
                        } 
                    ]
                }
                });
            }
            let  onAuthorize = (data, actions) => {
            var data = {
                "customer_id"   : localStorage.getItem("userId"),
                "vendor_id"     : localStorage.getItem("vendorId"),
                "amount"        : this.amount,
                "payment_id"    : data.paymentID,
                "payer_id"      : data.payerID,
                "token"         : localStorage.getItem("token"),
                "couponCode"    : ""
            };
                this.sendDataPaypal({data:data}).then(() => {
                    return actions.payment.execute().then(function() {
                       //   window.alert('Thank you for your purchase!');
                    });
                }).catch(err=>{
                    this.isLoading = false;
                    this.error= 'Error with your payment'  // to display  the error message 
                });
             }
             var actionStatus;
            paypal.Button.render({
                env: 'sandbox',
                client,
                payment,
                onAuthorize,
                locale: 'en_US',
                style: {
                    size: 'large',
                    color: 'blue',
                    shape: 'pill',
                },
                commit: true,
                onCancel: (data) => {
                    this.error= 'Payment Cancelled'
                },
                onError: (err) => {
                    this.error = "An error occurred while processing the paypal payment.";
                },
                // onAuthorize: function(data, actions) {
                //     return actions.payment.execute().then(payload => {
                //         // this.success= 'Amount added to your wallet successfully'
                //        window.alert('Amount added to your wallet successfully');
                //     });
                // }
            }, '#paypal-button');

            console.log('notification mounted');
        }

};
</script>
<style>
    body {
        padding: 20px;
    }
</style>